module.exports = __webpack_public_path__ + "img/introduce01.364dd7d4.png";